import React from "react";
import styles from "./styles/PlasticMouldingContent.module.css";
import { Reveal } from "../Home/common/Reveal";
import mainImg from "../../../images/PlasticMoulding (1).jpg";
import toolImg from "../../../images/PlasticMoulding (1).jpg";
import protoImg from "../../../images/PlasticMoulding (1).jpg";

const items = [
  {
    title: "PLASTIC MOULDING",
    image: mainImg,
    description:
      "Alliance Automation is carving its own niche by focusing on very critical and highly precision oriented segments. We are known for making innovations in processing methods, adopting to the new trends and advancing with most sophisticated Plastic injection molding and gas assisted injection molding machines. Our array of services includes injection molding, gas injection molding, product development, mold manufacturing, large scale productions, assembly jobs and development of injection molding techniques.",
  },
  {
    title: "TOOL DESIGN",
    image: toolImg,
    description:
      "Our tool design expertise ensures creative and robust tool solutions that offer value with the initial build as well as future maintenance cost savings. We can handle many complex tooling revisions, repairs, and complete refurbishments.",
  },
  {
    title: "PROTOTYPING",
    image: protoImg,
    description:
      "Alliance Automation can provide valuable advice when choosing the right prototyping approach. Through our capability and expertise we can provide prototype parts machined, molded, or through any of the various additive process technologies. 3D printing allows creative problem solving, cost effectiveness, lessens downtime and can be used in variety of departments throughout the company.",
  },
];

export default function PlasticMouldingContent() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {items.map((item, index) => (
            <Reveal key={item.title} delay={index * 80}>
              <article className={styles.product}>
                <div className={styles.imageWrap}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className={styles.productImage}
                    loading="lazy"
                  />
                </div>
                <h3 className={styles.productTitle}>{item.title}</h3>
                <div className={styles.productAccent} aria-hidden="true" />
                <p className={styles.productDescription}>{item.description}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
